import React, { useState } from "react";
import { CreditcardIcon } from "../../../Common/SvgIcons/WorkflowIcons";
import useFetch from "../../../../components/useFetch";
import Sidenav from "../../../navbar/Sidenav";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import getDataFromApi from "../../../../components/getDataFromApi";
import TitleHeader from "../../../project/header/TitleHeader";
import PathBreadcrumb from "../../../../components/PathBreadcrumb/PathBreadcrumb";

export const BillingTable = ({ billingUrl, tenantname }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const tenantId = localStorage.getItem("tenant_id");

    const navUrl = location?.state?.url;
    const tenantView = location?.state?.tenantname;

    const notTenant = tenantname || tenantView;

    // 🔹 Filters & Sorting
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [sortOrder, setSortOrder] = useState("asc"); // newest | oldest

    const fallbackBillingUrl = tenantId
        ? `admin/billings?page=1&per_page=5&filter=tenant_id=${tenantId}`
        : null;
    const baseUrl = billingUrl || navUrl || fallbackBillingUrl;
    const isStandaloneView = !billingUrl && !navUrl;


    // Split existing query
    const [path = "", queryString = ""] = (baseUrl || "").split("?");
    const params = new URLSearchParams(queryString);

    // Extract existing filter (like tenant_id=xxx)
    const existingFilter = params.get("filter");

    // Build filter parts array
    let filterParts = [];

    if (existingFilter) {
        filterParts.push(existingFilter);
    }

    // Add status filter if selected
    if (statusFilter !== "all") {
        filterParts.push(`status=${statusFilter}`);
    }

    // Set combined filter back
    if (filterParts.length > 0) {
        params.set("filter", filterParts.join(","));
    }

    // Sorting
    // Remove existing sort
    params.delete("sort");

    // Add correct sort format
    if (sortOrder) {
        params.set("sort", `created_at:${sortOrder}`);
    }

    const finalUrl = path ? `${path}?${params.toString()}` : null;


    const { data, loading, error } = useFetch(finalUrl, "GET");
    const billings = data?.results || [];



    const searchedBillings = billings.filter((bill) => {
        if (!search.trim()) return true;

        const searchText = search.toLowerCase();

        const searchableContent = [
            bill.plan_name,
            bill.tenant_name,
            bill.status,
            bill.amount_paid?.toString(),
            bill.currency,
        ]
            .join(" ")
            .toLowerCase();

        return searchableContent.includes(searchText);
    });


    const handleResetFilters = () => {
        setStatusFilter("all");
        setSortOrder("asc");
    };


    const handleDownload = async (invoiceId) => {
        try {
            const res = await getDataFromApi(
                `${window.ENV.API_URL}/admin/billings/${invoiceId}`,
                "GET"
            );

            const fileUrl = typeof res === "string" ? res : res?.data || res?.url;

            if (!fileUrl) {
                console.error("No file URL found");
                return;
            }

            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "invoice.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <>

            <div className={isStandaloneView ? "mainmenu projects-content de-width" : ""}>
                    {isStandaloneView && (
                        <PathBreadcrumb
                            onBack={() => { notTenant ? navigate("/admin") : navigate(-1) }}
                            items={
                                notTenant
                                    ? [
                                        { label: "Admin", onClick: () => navigate("/admin") },
                                        { label: "Billing" },
                                    ]
                                    : [
                                        { label: "Admin", onClick: () => navigate("/admin") },
                                        { label: "Tenant", onClick: () => navigate(-1) },
                                        { label: "Billing" },
                                    ]
                            }
                        />)}


                    {isStandaloneView && (
                        <div className={`mt-4 w-100 d-a flex-column flex-sm-row justify-content-between`}>
                            <TitleHeader Icon={CreditcardIcon} title1={'Billing'} title2={' Management'} subtext={`Monitor billing activity, payment status, and invoice records.`} />
                        </div>)}



                    {isStandaloneView && (
                        <div className="d-a gap-3 flex-column flex-sm-row justify-content-between my-4 w-100">
                            <div className="d-a gap-2 p-2 badge-border px-3 flex-fill sub-nav-mb-button">
                                <FontAwesomeIcon className="plain-button2 text-secondary" icon={faSearch} />
                                <input
                                    className="border-0 m-0 bg-transparent text w-100"
                                    style={{ outline: 'none' }}
                                    placeholder="Search plan, tenant, status..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            {/* 🔹 Filters */}
                            <div className="d-a gap-2 flex-wrap">

                                {/* Status Filter */}
                                <select
                                    className="form-select form-select-sm p-2 rounded bg-transparent m-0 px-3 h-100"
                                    style={{ width: "170px" }}
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="all">All Status</option>
                                    <option value="paid">Paid</option>
                                    <option value="pending">Pending</option>
                                    <option value="failed">Failed</option>
                                </select>

                                {/* Sort */}
                                <select
                                    className="form-select form-select-sm p-2 rounded bg-transparent m-0 px-3 h-100"
                                    style={{ width: "170px" }}
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Newest First</option>
                                    <option value="desc">Oldest First</option>
                                </select>

                                {/* Reset Button */}
                                {(statusFilter !== "all" || sortOrder !== "sort=created_at:desc") && (
                                    <button
                                        className="plain-button text-danger fw-semibold"
                                        onClick={handleResetFilters}
                                    >
                                        Clear
                                    </button>
                                )}

                            </div>
                        </div>
                    )}

                    {/* 🔹 Table */}
                    <div className="table-wrap mt-4">
                        <table className="tenant-table">
                            <thead>
                                <tr>
                                    <th className="th-left">Plan</th>
                                    {notTenant && <th>Tenant</th>}
                                    <th>Last Billed Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Next Billing Date</th>
                                    <th className="th-right">Download Invoice</th>
                                </tr>
                            </thead>

                            <tbody>
                                {!finalUrl ? (
                                    <tr>
                                        <td colSpan={notTenant ? 7 : 6} className="text-center py-4 text-secondary">
                                            Billing activity is unavailable for this tenant.
                                        </td>
                                    </tr>
                                ) : loading ? (
                                    <tr>
                                        <td colSpan={notTenant ? 7 : 6} className="text-center py-4">
                                            Loading billing activity...
                                        </td>
                                    </tr>
                                ) : error ? (
                                    <tr>
                                        <td colSpan={notTenant ? 7 : 6} className="text-center text-danger py-4">
                                            Failed to load billing activity
                                        </td>
                                    </tr>
                                ) : billings.length === 0 ? (
                                    <tr>
                                        <td colSpan={notTenant ? 7 : 6}>
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5">
                                                <div style={{ fontSize: "3rem" }}>📄</div>
                                                <h5 className="fw-semibold mb-2">
                                                    No billing data available
                                                </h5>
                                                <p className="text-secondary">
                                                    There are no billing records yet.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : searchedBillings.length === 0 ? (
                                    <tr>
                                        <td colSpan={notTenant ? 7 : 6}>
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5">
                                                <div style={{ fontSize: "3rem" }}>🔍</div>
                                                <h5 className="fw-semibold mb-2">
                                                    No matching billing records found
                                                </h5>
                                                <p
                                                    className="text-secondary mb-3 text-center"
                                                    style={{ maxWidth: "450px" }}
                                                >
                                                    Try adjusting your search or filters.
                                                </p>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => setSearch("")}
                                                >
                                                    Clear Search
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    searchedBillings.map((bill) => (
                                        <tr key={bill._id}>
                                            {/* Plan + Tenant */}
                                            <td>
                                                <div className="org d-flex gap-0 flex-column align-items-start">
                                                    <p className="text-capitalize m-0">
                                                        {bill.plan_name}
                                                    </p>
                                                </div>
                                            </td>

                                            {/* Amount */}

                                            {notTenant &&
                                                <td className="fw-bold small-font">
                                                    <span className="text-secondary text-capitalize">
                                                        Tenant - {bill.tenant_name}
                                                    </span> </td>}


                                            {/* Billing Date */}
                                            <td className="text-secondary small-font">
                                                {new Date(bill.paid_at).toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                    month: "short",
                                                    day: "2-digit",
                                                    // hour: "2-digit",
                                                    // minute: "2-digit",
                                                    // second: "2-digit",
                                                    // hour12: true,
                                                })}

                                            </td>

                                            {/* Amount */}
                                            <td className="fw-bold small-font">
                                                ${bill.amount_paid.toFixed(2)}
                                            </td>

                                            {/* Status */}
                                            <td className="text-start">
                                                <span
                                                    className={`pill ${bill.status === "paid"
                                                        ? "pill--active"
                                                        : "pill--inactive"
                                                        }`}
                                                >
                                                    {bill.status.toUpperCase()}
                                                </span>
                                            </td>

                                            {/* Period */}
                                            <td className="text-secondary small-font">
                                                {bill.period ? (
                                                    <>
                                                        {/* {new Date(bill.period.start * 1000).toLocaleDateString("en-US", {
                                                        month: "short",
                                                        day: "2-digit",
                                                    })}
                                                    {" - "} */}
                                                        {new Date(bill.period.end * 1000).toLocaleDateString("en-US", {
                                                            month: "short",
                                                            day: "2-digit",
                                                        })}
                                                    </>
                                                ) : "-"}
                                            </td>



                                            {/* Download */}
                                            <td className="text-end">
                                                <button className="plain-button" onClick={() => handleDownload(bill.invoice_id)}>
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
            );
};
